// Prosper's real service area (pruned Nov 2026) and the service+city pages that are individually written.
export const LOCAL_CITIES = [
  { slug: "prosper", name: "Prosper", lat: 33.236, lng: -96.801, hq: true },
  { slug: "celina", name: "Celina", lat: 33.325, lng: -96.784 },
  { slug: "frisco", name: "Frisco", lat: 33.151, lng: -96.824 },
  { slug: "little-elm", name: "Little Elm", lat: 33.163, lng: -96.938 },
  { slug: "aubrey", name: "Aubrey", lat: 33.304, lng: -96.986 },
  { slug: "gunter", name: "Gunter", lat: 33.448, lng: -96.748 },
  { slug: "pilot-point", name: "Pilot Point", lat: 33.397, lng: -96.961 },
  { slug: "oak-point", name: "Oak Point", lat: 33.181, lng: -96.991 },
  { slug: "cross-roads", name: "Cross Roads", lat: 33.223, lng: -96.993 },
  { slug: "providence-village", name: "Providence Village", lat: 33.234, lng: -96.962 },
];

export const LOCAL_SERVICE_SLUGS = [
  "garage-door-spring-repair",
  "garage-door-opener-repair",
  "new-garage-door-installation",
  "emergency-garage-door-repair",
  "garage-door-cable-repair",
];

const dist = (a, b) => Math.hypot(a.lat - b.lat, (a.lng - b.lng) * 0.84);

export const nearestCities = (slug, n = 5) => {
  const me = LOCAL_CITIES.find((c) => c.slug === slug);
  if (!me) return [];
  return LOCAL_CITIES.filter((c) => c.slug !== slug).sort((a, b) => dist(me, a) - dist(me, b)).slice(0, n);
};

// Removed cities -> closest kept city (used for 301-style redirects).
export const REMOVED_CITY_MAP = {
  mckinney: "prosper", melissa: "celina", anna: "celina", "collin-county": "prosper", allen: "frisco", plano: "frisco",
  wylie: "frisco", murphy: "frisco", sachse: "frisco", parker: "frisco", lucas: "frisco", fairview: "prosper",
  princeton: "celina", lavon: "celina", nevada: "celina", josephine: "celina", farmersville: "celina",
  "lowry-crossing": "prosper", "new-hope": "prosper", "st-paul": "prosper", weston: "celina", "blue-ridge": "celina",
  "the-colony": "little-elm", lewisville: "little-elm", carrollton: "frisco", richardson: "frisco", denton: "aubrey",
};

// Removed services -> closest kept page type ("hub" = the city hub page).
export const REMOVED_SERVICE_MAP = {
  "off-track-garage-door-repair": "hub",
  "garage-door-panel-replacement": "new-garage-door-installation",
  "garage-door-wont-close-repair": "hub",
  "garage-door-roller-replacement": "hub",
  "garage-door-remote-programming": "garage-door-opener-repair",
};

const KEPT = new Set(LOCAL_CITIES.map((c) => c.slug));

// Closest live page for any old /{service}/{city} URL, or null if the pair is live / unknown.
export const mapServiceCity = (svc, city) => {
  const c = KEPT.has(city) ? city : REMOVED_CITY_MAP[city];
  if (!c) return null;
  if (LOCAL_SERVICE_SLUGS.includes(svc)) return c === city ? null : `/${svc}/${c}`;
  const to = REMOVED_SERVICE_MAP[svc];
  if (!to) return null;
  return to === "hub" ? `/garage-door-repair/${c}` : `/${to}/${c}`;
};
